module.exports = __webpack_public_path__ + "img/couples_05_V.8333c275.webp";